document.addEventListener("touchstart", function() {}, true);

// if logged into the wordpress admin - won't cover top nav bar
$(document).ready(function() {
    if ($('#wpadminbar')[0]) {
        $('header').css('top', '32px')
    }
});

require('./vendor/sidr.min');
require('./vendor/swiper-bundle.min');

require('./helpers/custom-event-polyfill');
require('./helpers/padStar-polyfill');

require('./modules/fogo');
require('./modules/group-dining');
require('./modules/location-menu');
require('./modules/location-mobile');
// require('./modules/accordion');
require('./modules/menu-detail');
require('./modules/menu-request');
require('./modules/modal');
require('./modules/nav-scroll');
require('./modules/select');
require('./modules/time-btn');
require('./modules/top-nav-select-location');

require('./pages/locations');
require('./pages/loc-detail-scroll');
require('./pages/group-dining');
require('./pages/reservations');
require('./pages/sustainability');
require('./pages/forms');